import { METRICS_ACCESS_PATH } from 'cpmCarparks/navigation';

module.exports = {
  path: METRICS_ACCESS_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/CarparkMetricsAccess'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/routes/show/routes/metricsAccess/index.js